import findAbsence from '../availabilityHelpers/findAbsence'

// Class list for one rendered calendar occurrence. Must be called per
// occurrence (FullCalendar's eventClassNames hook), not per event object —
// a recurring personaSchedule series is one event with many occurrences,
// and only the occurrences inside an absence window may be marked.
// AI-CONTEXT: See docs/pitfalls.md#state-recurring-event-wrong-date
// AI-CONTEXT: See docs/patterns.md#ui-calendar-per-occurrence-class
const personaAbsenceClassNames = ({ type, personaId, start, end }, absences) => {
    if (type !== 'personaSchedule') return []
    if (!personaId || !start) return []

    // No end → 1ms-wide interval; a zero-width one never overlaps under the
    // strict comparisons in intervalsOverlap (misses starts at exact midnight).
    const windowEnd = end || new Date(start.getTime() + 1)
    const absence = findAbsence(absences, personaId, start, windowEnd)
    return absence ? ['fc-persona-absent'] : []
}

export default personaAbsenceClassNames
